module.exports = __webpack_public_path__ + "img/symbol_5.c1518697.png";